import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanDeactivateGuard } from './services/common/can-deactivate-guard.service';
import { DummyComponent } from './dummy.component';
import { PreferredLandingGuard } from './services/common/preferred-landing.guard';
import { AuthGuard, AuthRedirectComponent } from 'quangular';
const routes: Routes = [
    {
        path: 'auth',
        component: AuthRedirectComponent
    },
    {
        path: '',
        canActivate: [PreferredLandingGuard],
        component: DummyComponent
    },
    {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('./layouts/main-layout/main.module').then((m) => m.MainModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule],
    providers: [CanDeactivateGuard]
})
export class AppRoutingModule { }
